const CFUI2_BASENAME = '/oss_redesign/ui-modules_redesign/';
const WEBU_BASENAME = '/oss/';

const readIsWebUFromPage = () => {
    if (typeof document === 'undefined') {
        return false;
    }
    const meta = document.querySelector('meta[name="is-webu"]');
    return meta?.getAttribute('content') === 'true';
};

// Set once from server-rendered meta (brand-site WebU only, not /oss/o/d/ on Azure CFUI2).
const isWebUSession = readIsWebUFromPage();

export const isWebUPath = () => isWebUSession;

export const getRouterBasename = () => (isWebUSession ? WEBU_BASENAME : CFUI2_BASENAME);
